export default __webpack_public_path__ + "static/media/onboarding-card-4.add7f834.jpg";